import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Layout from './Layout';
import Dashboard from '../pages/Dashboard';

// @@CLIENT_PORTAL_v1@@
// Root "/" resolver. A client lands on the client portal; everyone else gets
// the internal dashboard. Keeps Login/SetPassword's navigate('/') working for
// every role without special-casing them. While auth is resolving, PrivateRoute
// upstream already shows a loader, so here user is known.
export default function RoleHome() {
  const { user } = useAuth();
  if (user && user.role === 'client') return <Navigate to="/portal" replace />;
  return <Layout><Dashboard /></Layout>;
}
